/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {WlElectronicSignaturePurposePopupComponent} from "../wl-electronic-signature-purpose-popup/wl-electronic-signature-purpose-popup.component";
import {SignerService} from "../../services/signer.service";
import {RootScopeService} from "../../services/rootscope.service";
import {SessionService} from "../../services/session.service";
import {RedirectionService} from "../../services/redirection.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-wl-electronic-signature-purpose',
    templateUrl: './wl-electronic-signature-purpose.component.html'
})
export class WlElectronicSignaturePurposeComponent implements OnInit {

    constructor(private route: ActivatedRoute, private redirectionService: RedirectionService, private sessionService: SessionService, private rootScope: RootScopeService, private signersService: SignerService, private modalService: NgbModal) {
    }

    toDisplay = false;

    private personalDataConsent;


    ngOnInit(): void {
        if (this.signersService.currentSigner && this.signersService.currentSigner.globalPersonalDataConsent) {
            sessionStorage.setItem('personalDataConsent', JSON.stringify(this.signersService.currentSigner.globalPersonalDataConsent));
            this.personalDataConsent = this.signersService.currentSigner.globalPersonalDataConsent;
            console.log('Current PersonalDataConsent from scope', this.personalDataConsent);
        } else {
            this.personalDataConsent = JSON.parse(sessionStorage.getItem('personalDataConsent') as string);
            console.log('Current PersonalDataConsent from storage', this.personalDataConsent);
        }

        this.toDisplay = (this.rootScope.get().properties.contact && this.rootScope.get().properties.contact === 'page') || this.personalDataConsent;
    }

    displayGlobalConsent() {
        if (this.personalDataConsent) {
            //Close all dialogs
            this.modalService.dismissAll();
            let popup = this.modalService.open(WlElectronicSignaturePurposePopupComponent, {
                size: 'lg',
                centered: true
            });
            popup.componentInstance.personalDataConsent = this.personalDataConsent;
        } else if (this.rootScope.get().properties.contact) {
            //Here we redirect to the contact page
            this.redirectionService.internalContact(this.route, this.sessionService.id);
        }
    }

}
